import { useLocation } from 'react-router';

import { useIsWidget } from '@app/hooks';

import { matchesPath, toSidebarPath } from './isSidebarLinkActive';

export const useSidebarUrl = (menuLinks: string[] = []): string => {
  const { pathname, search } = useLocation();
  const isWidget = useIsWidget();

  const routerUrl = `${pathname}${search}`;

  if (!isWidget) {
    return routerUrl;
  }

  const isRouterPathInMenu = menuLinks.some((link) => {
    return matchesPath(toSidebarPath(routerUrl), toSidebarPath(link));
  });

  if (isRouterPathInMenu) {
    return routerUrl;
  }

  return `${window.location.pathname}${window.location.search}`;
};
